export const NO_TASKS_MESSAGE = {
  FILTER: 'No Tasks to Display',
  NO_TASKS: 'You have no tasks to complete at this time',
};
